"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformAssignationStatusToString = transformAssignationStatusToString;
const legacy_enums_1 = require("@daytrip/legacy-enums");
function transformAssignationStatusToString(status) {
    switch (status) {
        case legacy_enums_1.AssignationStatus.Pending:
            return "pending";
        case legacy_enums_1.AssignationStatus.Accepted:
            return "accepted";
        case legacy_enums_1.AssignationStatus.Declined:
            return "declined";
        case legacy_enums_1.AssignationStatus.Cancelled:
            return "cancelled";
        default:
            return "unknown status";
    }
}
//# sourceMappingURL=transformAssignationStatusToString.js.map